<template>
  <page-option :disable-add="!checkAccess('workspace.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-map</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.layer-group.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        :disableCreate="!checkAccess('user.create')"
        placeholder="Tìm kiếm theo tên hoặc hệ quy chiếu"
        @click:create="onCreateItem()"
        can-show-in-search
      >
        <div class="filter-item">
          <field-group
            v-model="params.workspace_id"
            background-color="#FFFFFF"
            dense
            :items="workspace.items"
            :label="$t('sidebar.workspace.name')"
            :loading="workspace.loading"
            no-label
            outlined
            hide-details
            typeInput="v-select"
            item-text="name"
            item-value="id"
            clearable
          >
          </field-group>
        </div>
      </FilterSearch>
      <v-card
        class="d-flex align-md-center pa-2 flex-column flex-md-row my-2"
        outlined
        tile
      >
        <div>Chọn lớp ở dưới để thêm vào bản đồ</div>
        <v-spacer></v-spacer>
        <base-button
          className="ml-1"
          @click="onPreview(form_map.layers)"
          outlined
          :disabled="form_map.layers.length < 1"
        >
          Xem trước
        </base-button>
      </v-card>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        v-model="form_map.layers"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-selected
        multi-select
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span>
            {{ item.created_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>
            {{ item.updated_at | dateTime('short') }}
          </span>
        </template>
        <template #grid-item="{ item }">
          <layer-group-item :value="item" :workspace="item.workspace">
            <div class="d-flex pt-2">
              <div class="btn-group">
                <base-button
                  class="text-none"
                  small
                  text
                  @click="onPreview([item])"
                >
                  <v-icon small left>mdi-eye</v-icon>
                  <span>{{ $t('layer.action.preview') }}</span>
                </base-button>
                <base-button
                  class="text-none"
                  small
                  text
                  color="primary"
                  @click="onGotoDetail(item)"
                >
                  <v-icon small left>mdi-cog</v-icon>
                  <span>{{ $t('workspace.setting') }}</span>
                </base-button>
                <base-button
                  type-action="delete"
                  class="text-none"
                  small
                  text
                  @click.stop="onDeleteItem(item)"
                  v-if="checkAccess('workspace.delete', item)"
                >
                </base-button>
              </div>
            </div>
          </layer-group-item>
        </template>
        <template v-slot:[`item.home_public`]="{ item }">
          <v-switch
            v-model="item.home_public"
            @change="changeTrangThai(item.id)"
            :loading="loading_switch == item.id"
          ></v-switch>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <LayerGroupDetail ref="dialog_detail" @reset="onReset" />
    <LayerGroupDialog ref="dialog" :workspace="workspace" />
  </page-option>
</template>

<script>
import LayerGroupItem from './all-layer-group-item.vue'
import FilterSearch from '@layouts/filter-search.vue'
import { API_LAYERGROUP, API_WORKSPACE, API_LAYER } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import LayerGroupDetail from '../layer-group-detail.vue'
import LayerGroupDialog from './all-layer-group-dialog.vue'
export default {
  mixins: [],
  components: {
    LayerGroupItem,
    LayerGroupDetail,
    FilterSearch,
    LayerGroupDialog,
  },
  props: {},
  data: (vm) => ({
    form_map: {
      layers: [],
    },
    default_params: {
      with: 'workspace',
    },
    params: { search: '', inactive: null, workspace_id: '', with: 'workspace' },
    menus: [
      {
        icon: 'mdi-eye',
        title: vm.$t('layer.action.preview'),
        handler: (item) => vm.onPreview([item]),
        disabled: (item) => !vm.checkAccess('layergroup.update', item),
      },
      {
        type: 'setting',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('layergroup.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('layergroup.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'layer.belong_to_workspace',
        align: 'start',
        sortable: false,
        value: 'workspace.name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
    loading_switch: null,
    resource_headers: [
      {
        trans: 'datastore.layer.name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'datastore.layer.action',
        align: 'start',
        sortable: false,
        value: 'action',
      },
    ],
    resource_default_params: {},
    resource_params: { search: '', inactive: null },
    workspace: {
      loading: false,
      items: [],
    },
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_LAYERGROUP
    },
  },
  created() {},
  mounted() {
    this.getWorkspaces()
  },
  methods: {
    async changeTrangThai(id) {
      this.loading_switch = id
      let res = await API_LAYER.publicLayer(id, { type: 'layerGroup' })
      if (res.isDone) {
        this.loading_switch = null
      } else this.onReset()
    },
    onGotoDetail(item) {
      this.$refs.dialog_detail.open(item, EDIT_TYPE.UPDATE)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$emit('click:add-map', {})
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog_detail.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
    onPreview(layers) {
      if (!layers || layers.length < 1) return
      this.$router.push({
        name: 'map',
        query: { map_ids: layers.map((x) => x.id).join(',') },
      })
    },
    getWorkspaces() {
      this.workspace.loading = true
      API_WORKSPACE.list()
        .then((res) => {
          this.workspace.items = res.data
        })
        .finally(() => {
          this.workspace.loading = false
        })
    },
  },
}
</script>
